import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=a62bd05e&scoped=true"
var script = {}
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=a62bd05e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62bd05e",
  null
  
)

export default component.exports